import React from 'react';
import { Link } from 'react-router-dom';

const Settings: React.FC = () => {
  const settingsSections = [
    {
      id: 'apr-setup',
      title: 'APR Setup',
      description: 'Configure the APR framework dimensions, components, attributes, and scoring models',
      icon: '🏗️',
      path: '/framework',
      items: [
        { label: 'Dimensions & Components', path: '/framework/dimensions', icon: '📋' },
        { label: 'Data Attributes and Weightage', path: '/framework/attributes', icon: '⚖️' },
        { label: 'Questionnaire Setup', path: '/framework/questionnaire', icon: '❓' },
        { label: 'Disposition Matrix', path: '/framework/scoring-model', icon: '🎯' }
      ]
    }
  ];

  return (
    <div className="page">
      {/* Header */}
      <div className="page-header">
        <div className="page-header__content">
          <div className="page-header__title-section">
            <h1 className="page-header__title">Settings</h1>
            <p className="page-header__subtitle">
              Configure and manage your APR framework settings
            </p>
          </div>
          <div className="page-header__actions">
          </div>
        </div>
      </div>

      {/* Main Content Container */}
      <div className="master-data-container">
        {/* Settings Sections */}
        <div className="settings-grid">
          {settingsSections.map(section => (
            <div key={section.id} className="md-card md-card--outlined settings-section">
              <div className="md-card__content">
                <div className="settings-section__header">
                  <div className="settings-section__icon">{section.icon}</div>
                  <div className="settings-section__info">
                    <h3 className="settings-section__title">{section.title}</h3>
                    <p className="settings-section__description">{section.description}</p>
                  </div>
                </div>
                
                {section.items.length > 0 && (
                  <div className="settings-section__items">
                    {section.items.map(item => (
                      <Link 
                        key={item.path} 
                        to={item.path} 
                        className="settings-item"
                      >
                        <span className="settings-item__icon">{item.icon}</span>
                        <span className="settings-item__label">{item.label}</span>
                        <span className="settings-item__arrow">→</span>
                      </Link>
                    ))}
                  </div>
                )}
                
                <div className="md-card__actions">
                  <Link to={section.path} className="md-button md-button--filled">
                    Open {section.title}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Settings;